export const APP_CHAT = 'iChat';
